
const Images ={
    LOGO: require('../images/logo.png'),
    BANNER0: require("../images/banner0.png"),
    BANNER1: require("../images/banner1.png"),
    CAROUSEL1: "https://i.ibb.co/v4jqhtMB/carousel1.jpg",
    CAROUSEL2: "https://i.ibb.co/DZRxF3b/carousel2.jpg",
    CAROUSEL3: "https://i.ibb.co/Vc8FTNr4/carousel3.jpg",
    FACEBOOK: require("../images/facebook.svg"),
    INSTAGRAM: require("../images/instagram.svg"),
    TWITTER: require("../images/twitter.svg"),
    LOAD: require("../images/load.gif"),
    DOT1: require("../images/dot.png"),
    DOT2: require("../images/dot2.png"),
    SPEAKER: require("../images/speaker.png")
    
    

}
export default Images